import { render, staticRenderFns } from "./PatientDetailResvClinic.vue?vue&type=template&id=2c888399&scoped=true&"
import script from "./PatientDetailResvClinic.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailResvClinic.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailResvClinic.vue?vue&type=style&index=0&id=2c888399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c888399",
  null
  
)

export default component.exports